<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <ArenaPointTypeForm v-if="pointType" :pointType="pointType" />
      <LoadingPage v-if="!pointType"/>
    </PageRowWrapper>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaPointTypeForm from '@/components/settings/arena/point-type/ArenaPointTypeForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'ArenaPointTypeEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    ArenaPointTypeForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      pointType: state => state.arena.pointTypeById
    })
  },
  methods: {
    ...mapActions('arena', ['fetchArenaPointTypeById'])
  },
  mounted () {
    this.fetchArenaPointTypeById(this.$route.params.id)
  }
}
</script>
